import { fromJS } from 'immutable';


const commonLanguages = fromJS({
    
    fr: async () => (await import('react-intl/locale-data/fr.js')).default,
    en: async () => (await import('react-intl/locale-data/en.js')).default,
    es: async () => (await import('react-intl/locale-data/es.js')).default,
    sv: async () => (await import('react-intl/locale-data/sv.js')).default,
    de: async () => (await import('react-intl/locale-data/de.js')).default
});


export async function dynamicLocaleImport(locale) {
    
    
    
    
    const language = locale.split('-')[0];
    if (commonLanguages.has(language)) {
        return commonLanguages.get(language)();
    }
    
    return (await import(`react-intl/locale-data/${language}.js`)).default;
}
